
import { Component, Vue } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'

import { Http } from '@/lib/utils/Http'

import TeamareaStatTable from '@/components/admin/statistics/TeamareaStatTable.vue'

// eslint-disable-next-line
import am4themes_animated from '@amcharts/amcharts4/themes/dark'
am4core.useTheme(am4themes_animated)

@Component({
  components: {
    BacLoggedInHeader,
    TeamareaStatTable
  }
})
export default class TeamareaStats extends Vue {
  loginChart?: am4charts.Chart;
  lastLogins = []
  postsChart?: am4charts.Chart;

  headers = [
    { text: 'Name', value: 'name' },
    { text: 'E-Mail', value: 'email' },
    { text: 'Zeitpunkt', value: 'time' }
  ]

  get lastLoginsTableItems () {
    return this.lastLogins.map((lastLogin: any) => {
      return {
        name: `${lastLogin.customer.firstname} ${lastLogin.customer.lastname}`,
        email: lastLogin.customer.email,
        time: lastLogin.create_datetime
      }
    })
  }

  mounted () {
    this.createLoginChart()
    this.loadLastLogins()
    this.createPostsChart()
  }

  async createPostsChart () {
    const chart = am4core.create(this.$refs.postChart as any, am4charts.XYChart)

    chart.paddingRight = 20

    const data = await (await Http.request('/api/statistic/posts-per-day')).json()

    chart.data = data

    const dateAxis = chart.xAxes.push(new am4charts.DateAxis())
    dateAxis.renderer.grid.template.location = 0

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    (valueAxis as any).tooltip.disabled = true
    valueAxis.renderer.minWidth = 35

    const series = chart.series.push(new am4charts.LineSeries())
    series.dataFields.dateX = 'date'
    series.dataFields.valueY = 'value'

    series.tooltipText = '{valueY.value}'
    chart.cursor = new am4charts.XYCursor()

    const scrollbarX = new am4charts.XYChartScrollbar()
    scrollbarX.series.push(series)
    chart.scrollbarX = scrollbarX

    this.postsChart = chart
  }

  async loadLastLogins () {
    this.lastLogins = await (await Http.request('/api/statistic/last-logins')).json()
  }

  async createLoginChart () {
    const chart = am4core.create(this.$refs.loginChart as any, am4charts.XYChart)

    chart.paddingRight = 20

    const data = await (await Http.request('/api/statistic/logins-per-day')).json()

    chart.data = data

    const dateAxis = chart.xAxes.push(new am4charts.DateAxis())
    dateAxis.renderer.grid.template.location = 0

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    (valueAxis as any).tooltip.disabled = true
    valueAxis.renderer.minWidth = 35

    const series = chart.series.push(new am4charts.LineSeries())
    series.dataFields.dateX = 'date'
    series.dataFields.valueY = 'value'

    series.tooltipText = '{valueY.value}'
    chart.cursor = new am4charts.XYCursor()

    const scrollbarX = new am4charts.XYChartScrollbar()
    scrollbarX.series.push(series)
    chart.scrollbarX = scrollbarX

    this.loginChart = chart
  }

  beforeDestroy () {
    if (this.loginChart) {
      this.loginChart.dispose()
    }

    if (this.postsChart) {
      this.postsChart.dispose()
    }
  }
}
